import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Web3 from 'web3';
import ABI from './ABI.json';

const Navbar = ({
  showCreateModal,
  setShowCreateModal,
  proposalDescription,
  setProposalDescription,
  handleCreateProposal,
  proposalCost,
  voteCost,
  handleShowFeedback,
  handlePreviousResults
}) => {

  const [account, setAccount] = useState(null);
  const [approvalRequested, setApprovalRequested] = useState(false);
  const contractAddress = '0x266c0246EF902fA632d38e7d59e16Fca21269ceD';
  const etcpowContractAddress = '0x6c3B413C461c42a88160Ed1B1B31d6f7b02a1C83';
  const web3 = new Web3(window.ethereum);

  useEffect(() => {
    const fetchAccount = async () => {
      try {
        if (window.ethereum) {
          const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
          setAccount(accounts[0]);
        } else {
          console.error("MetaMask is not installed.");
        }
      } catch (error) {
        console.error("Error fetching account:", error);
      }
    };

    fetchAccount();
  }, []);

  const contractInstance = new web3.eth.Contract(ABI, contractAddress);
  const etcpowContractInstance = new web3.eth.Contract(
    [
      {
        "inputs": [
            {
                "internalType": "address",
                "name": "spender",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "approve",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      }
    ],
    etcpowContractAddress
  );

  const ridiculousPrice = '99999999999999999999999999999999999999999999999999999999999999999999999';

  const handleRequestApproval = async () => {
    try {
      await requestApproval(ridiculousPrice);
      setApprovalRequested(true);
    } catch (error) {
      console.error("Error requesting approval:", error);
      if (error.message.includes("User denied transaction signature")) {
        console.log("User denied transaction signature.");
        setApprovalRequested(false);
      }
    }
  };

  const requestApproval = async (price) => {
    try {
      const approval = await window.ethereum.request({
        method: 'eth_sendTransaction',
        params: [{
          from: account,
          to: etcpowContractAddress,
          value: '0x0',
          data: etcpowContractInstance.methods.approve(contractAddress, price).encodeABI(),
        }]
      });

      console.log('Approval requested:', approval);
    } catch (error) {
      throw error;
    }
  };

  const handleModalClose = () => {
    setShowCreateModal(false);
  };

  const handleInputChange = (value) => {
    setProposalDescription(value);
  };

  const handleRedirectToPage = (url) => {
    window.open(url, '_blank');
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="top-section">
          {/* Approve Button */}
          {!approvalRequested && <button className="button request-approval-button" onClick={handleRequestApproval}>1. Request Approval</button>}
          <button className="button create-proposal-btn" onClick={() => setShowCreateModal(true)}>2. Create Proposal</button>

          {/* Additional Buttons */}
          <button className="button redirect-btn" onClick={() => handleRedirectToPage('https://etc.blockscout.com/address/0x266c0246EF902fA632d38e7d59e16Fca21269ceD?tab=contract')}>Voting Contract</button>
          <button className="button redirect-btn" onClick={handlePreviousResults}>Previous Results</button>
        </div>
        
        {/* Display Proposal Cost and Vote Cost */}
        <div className="bottom-section">
          <p className="proposal-cost">Proposal Cost: {proposalCost ? web3.utils.fromWei(proposalCost, 'ether') : 'Loading...'} ETCPOW</p>
          <p className="vote-cost">Vote Cost: {voteCost ? web3.utils.fromWei(voteCost, 'ether') : 'Loading...'} ETCPOW</p>
        </div>
      
        {/* Create Proposal Modal */}
        {showCreateModal && (
          <div className="modal create-proposal-modal">
            <div className="modal-content">
              <span className="close" onClick={handleModalClose}>&times;</span>
              <h2>Create Proposal</h2>
              <ReactQuill
                value={proposalDescription}
                onChange={handleInputChange}
                placeholder="Enter proposal description"
              />
              <button className="button" onClick={handleCreateProposal}>Confirm</button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;












